// extracted by mini-css-extract-plugin
export default {"bottomBar":"bottomBar__vjJG3","active":"active__e1s-f"};